export { default } from "bullitttime-embercomponents/components/status-light";
